import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  retrieve_audit_trails: { status: "idle" },
};

export const retrieve_audit_trails_Slice = createSlice({
  name: "retrieve_audit_trails",
  initialState,
  reducers: {
    success_retrieve_audit_trails: (state, action) => {
      state.retrieve_audit_trails = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_retrieve_audit_trails: (state, action) => {
      state.retrieve_audit_trails = { status: app_consts.FAIL, message: action.payload };
    },
    reset_retrieve_audit_trails: (state) => {
      state.retrieve_audit_trails = { status: app_consts.IDLE };
    },
    loading_retrieve_audit_trails: (state) => {
      state.retrieve_audit_trails = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_retrieve_audit_trails,
  fail_retrieve_audit_trails,
  reset_retrieve_audit_trails,
  loading_retrieve_audit_trails,
} = retrieve_audit_trails_Slice.actions;

export default retrieve_audit_trails_Slice.reducer;
